import { render } from "./SidebarNavigation.vue?vue&type=template&id=2e791448&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"

import "./SidebarNavigation.vue?vue&type=style&index=0&id=2e791448&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e791448"]])

export default __exports__